// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    border: thin solid var(--main-border-color);
    border-radius: 7px;
    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    padding: 7px;
}
`, "",{"version":3,"sources":["webpack://./client/components/ui/Card/Card.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,6CAA6C;IAC7C,YAAY;AAChB","sourcesContent":[".card {\n    border: thin solid var(--main-border-color);\n    border-radius: 7px;\n    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    padding: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
